import { filterVisibleItems } from '../../../utils/common'
import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
} from '../../Entity'
import { NEWSBOARD_TYPES_KEYS } from '../Newsboard.constants'

import { NewsboardPostProfileHeaderInfoItemName } from './NewsboardPostProfileHeaderInfoItems.constants'

export function isNewsboardPostProfileHeaderInfoItemNameComments(name) {
  return name === NewsboardPostProfileHeaderInfoItemName.Comments
}

export function getEditActionHandlers(onClick) {
  return {
    [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD]: { onClick },
    [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT]: { onClick },
  }
}

export function getNewsboardPostProfileHeaderInfoItems({
  isCommentsToggleVisible,
  isPostAgeVisibleToUser,
  postData,
  t,
  timeRange,
}) {
  const typeKey = postData?.post_type?.title
    ? NEWSBOARD_TYPES_KEYS[postData.post_type.title]
    : null
  const typeValue = typeKey ? t(typeKey) : null

  const postAge =
    postData?.post_age_to_add_new_user != null
      ? String(postData.post_age_to_add_new_user)
      : null

  const canViewTimeRange = postData?.permissions?.can_view_date_period

  return filterVisibleItems([
    {
      canEdit: false,
      isVisible: true,
      name: NewsboardPostProfileHeaderInfoItemName.Type,
      value: typeValue,
    },
    {
      canEdit: postData?.permissions?.can_edit_post_age_to_add_new_user,
      isVisible: !postData?.isTvTicker && isPostAgeVisibleToUser,
      name: NewsboardPostProfileHeaderInfoItemName.PostAge,
      value: postAge,
    },
    {
      canEdit: postData?.permissions?.can_edit_date_period,
      isVisible: canViewTimeRange,
      name: NewsboardPostProfileHeaderInfoItemName.TimeRange,
      value: timeRange,
    },
    {
      canEdit: postData?.permissions?.can_edit,
      isVisible: !postData?.isTvTicker && isCommentsToggleVisible,
      name: NewsboardPostProfileHeaderInfoItemName.Comments,
      value: !postData?.comments_forbidden,
    },
  ])
}
